import {
  LucideArrowLeftRight,
  LucideBanknote,
  LucideBitcoin,
  LucideCreditCard,
  LucidePiggyBank,
  LucideScale,
  LucideUmbrellaOff
} from 'lucide-vue-next'

export const seo = {
  title: 'page.faq.mocks.seo.title',
  ogTitle: 'page.faq.mocks.seo.og_title'
}

export const banner = {
  heading: 'page.faq.mocks.banner.heading',
  text: 'page.faq.mocks.banner.text',
  linkUrl: '/cards',
  linkText: 'page.faq.mocks.banner.link_text'
}

export const categories = [
  {
    label: 'common.bank_cards',
    value: 'cards',
    icon: LucideCreditCard
  },
  {
    label: 'common.credits',
    value: 'credits',
    icon: LucideBanknote
  },
  {
    label: 'common.deposits',
    value: 'deposits',
    icon: LucidePiggyBank
  },
  {
    label: 'common.transfers',
    value: 'transfers',
    icon: LucideArrowLeftRight
  },
  {
    label: 'common.crypto',
    value: 'crypto',
    icon: LucideBitcoin
  },
  {
    label: 'common.insurance',
    value: 'insurance',
    icon: LucideUmbrellaOff
  },
  {
    label: 'page.faq.mocks.categories.taxes_and_laws',
    value: 'taxes_and_laws',
    icon: LucideScale
  }
]

export default {
  seo,
  banner,
  categories
}
